/** App 下载地址 */
export const APP_DOWNLOAD = {
  androidUrl: 'https://oss.harence.com/down/harence-jiazhuang.apk',
  iosUrl: 'https://itunes.apple.com/cn/app/id6810489590?ls=1&mt=8'
}

export function appDownloadPageUrl() {
  if (typeof window === 'undefined') return '/#/app-download'
  const origin = window.location.origin || ''
  const path = (window.location.pathname || '/').replace(/\/index\.html$/, '/')
  const base = (origin + path).replace(/\/?$/, '/')
  return base + '#/app-download'
}
